import ArchetypeHealer from './ArchetypeHealer'

export default ArchetypeHealer
// eslint-disable-next-line import/export
export * from './ArchetypeHealer'
